// extracted by mini-css-extract-plugin
export default {"row":"LoadingPage_row__umJeu","wrapperPageLoading":"LoadingPage_wrapperPageLoading__WVSeB","loaderSpinner":"LoadingPage_loaderSpinner__n5+Bo"};